import { render, staticRenderFns } from "./prncatg.vue?vue&type=template&id=643dc84b"
import script from "./prncatg.vue?vue&type=script&lang=js"
export * from "./prncatg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports